import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import api from "../lib/api";

/**
 * Shown on the host dashboard when the user has banked tier credits
 * (from a prior Classic/Grand purchase) that have NOT been applied to
 * any event yet. Click-through lands on the credits-redeem flow.
 */
const TIER_LABEL = { petite: "Petite", classic: "Classic", grand: "Grand", kids: "Kids Party" };

const UnclaimedCreditsBanner = () => {
  const [credits, setCredits] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get("/users/me/credits")
      .then((r) => { if (!cancelled) setCredits(r.data?.credits || {}); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  if (loading) return null;
  const total = Object.values(credits).reduce((a, b) => a + (Number(b) || 0), 0);
  if (total <= 0) return null;

  const pieces = Object.entries(credits)
    .filter(([, n]) => Number(n) > 0)
    .map(([tier, n]) => `${n} ${TIER_LABEL[tier] || tier}`);

  return (
    <div
      data-testid="unclaimed-credits-banner"
      className="bg-gradient-to-r from-emerald-50 to-cream-100 border border-emerald-200 rounded-2xl p-5 flex flex-wrap items-center gap-4 justify-between"
    >
      <div className="flex items-start gap-3 min-w-0">
        <div className="w-10 h-10 rounded-full bg-emerald-500 text-white flex items-center justify-center shrink-0">
          <Gift className="w-5 h-5" />
        </div>
        <div className="min-w-0">
          <div className="font-semibold text-navy-700">
            You have {total} unused gallery credit{total === 1 ? "" : "s"}
          </div>
          <div className="text-sm text-navy-700/70 mt-0.5">
            {pieces.join(" · ")} — apply to any event to upgrade it instantly, no checkout.
          </div>
        </div>
      </div>
      <Link
        to="/dashboard"
        data-testid="unclaimed-credits-cta"
        className="shrink-0 inline-flex items-center gap-2 bg-emerald-500 text-white px-4 py-2 rounded-full text-sm font-semibold hover:bg-emerald-600"
        onClick={(e) => {
          e.preventDefault();
          const first = document.querySelector('[data-testid^="dashboard-renew-"]');
          if (first) first.scrollIntoView({ behavior: "smooth", block: "center" });
        }}
      >
        Pick an event to upgrade
      </Link>
    </div>
  );
};

export default UnclaimedCreditsBanner;
